package com.partejar.app.feature.contratos.presentation

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.tooling.preview.Preview
import com.partejar.app.core.ui.components.*
import com.partejar.app.core.ui.theme.*
import com.partejar.app.feature.contratos.data.ContractSetupRequirements

@Composable
internal fun ContractSetupRequired(requirements: ContractSetupRequirements, onCreatePlan: () -> Unit, onCreateTemplate: () -> Unit, modifier: Modifier = Modifier) {
    val spacing = PartejarTheme.spacing
    val completed = listOf(requirements.missingPlan, requirements.missingTemplate).count { !it }
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(spacing.space16)) {
        Column(verticalArrangement = Arrangement.spacedBy(spacing.space8)) {
            Text("Vamos preparar seu contrato", style = MaterialTheme.typography.titleLarge)
            Text("Complete os cadastros do seu espaço. Eles serão usados para montar o contrato deste relacionamento.",
                style = MaterialTheme.typography.bodyMedium, color = MaterialTheme.colorScheme.onSurfaceVariant)
            Text("$completed de 2 cadastros prontos", style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary)
            LinearProgressIndicator(progress = { completed / 2f }, modifier = Modifier.fillMaxWidth().clip(PartejarShapes.pill))
        }
        ContractSetupStep(1, "Plano de atendimento", !requirements.missingPlan,
            "Defina o valor e os serviços que serão oferecidos no contrato.",
            PartejarIcons.Contracts.condition, "Cadastrar plano", onCreatePlan)
        ContractSetupStep(2, "Modelo de contrato", !requirements.missingTemplate,
            "Prepare o texto base com as condições do atendimento.",
            PartejarIcons.Contracts.template, "Cadastrar modelo", onCreateTemplate)
        PartejarCard(modifier = Modifier.fillMaxWidth()) {
            Row(horizontalArrangement = Arrangement.spacedBy(spacing.space12), verticalAlignment = Alignment.Top) {
                StepMarker(3, false)
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(spacing.space4)) {
                    Text("Preparar o contrato", style = MaterialTheme.typography.titleSmall)
                    Text(if (requirements.isMissing) "Próximo passo · complete os cadastros acima" else "Tudo pronto para continuar",
                        style = MaterialTheme.typography.labelMedium, color = MaterialTheme.colorScheme.primary)
                    Text("Escolha o plano e o modelo, revise os dados e defina quem vai assinar.",
                        style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
            }
        }
        Text("Ao salvar cada cadastro, volte à preparação para acompanhar o que falta.",
            style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
    }
}

@Composable
private fun ContractSetupStep(number: Int, title: String, completed: Boolean, description: String,
                              icon: ImageVector, actionLabel: String, onAction: () -> Unit) {
    val spacing = PartejarTheme.spacing
    PartejarCard(modifier = Modifier.fillMaxWidth()) {
        Column(verticalArrangement = Arrangement.spacedBy(spacing.space12)) {
            Row(horizontalArrangement = Arrangement.spacedBy(spacing.space12), verticalAlignment = Alignment.Top) {
                StepMarker(number, completed)
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(spacing.space4)) {
                    Text(title, style = MaterialTheme.typography.titleSmall)
                    Text(if (completed) "Concluído" else "Pendente", style = MaterialTheme.typography.labelMedium,
                        color = if (completed) PartejarTheme.colors.onSuccessContainer else MaterialTheme.colorScheme.primary)
                    Text(if (completed) "Cadastro disponível neste espaço." else description,
                        style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
            }
            if (!completed) PartejarButton(text = actionLabel, onClick = onAction,
                variant = PartejarButtonVariant.SECONDARY, shape = PartejarShapes.pill,
                leadingIcon = { Icon(icon, null, Modifier.size(PartejarTheme.dimensions.iconMedium)) })
        }
    }
}

@Composable
private fun StepMarker(number: Int, completed: Boolean) {
    Surface(shape = CircleShape,
        color = if (completed) PartejarTheme.colors.successContainer else MaterialTheme.colorScheme.primaryContainer,
        contentColor = if (completed) PartejarTheme.colors.onSuccessContainer else MaterialTheme.colorScheme.onPrimaryContainer) {
        Box(Modifier.size(PartejarTheme.dimensions.minimumTouchTarget), contentAlignment = Alignment.Center) {
            if (completed) Icon(PartejarIcons.Feedback.success, null, Modifier.size(PartejarTheme.dimensions.iconMedium))
            else Text(number.toString(), style = MaterialTheme.typography.titleMedium)
        }
    }
}

@Preview(name = "Preparação · pendente", widthDp = 375, heightDp = 850)
@Composable private fun ContractSetupPendingPreview() = PartejarTheme(ThemeMode.LIGHT) {
    Column(Modifier.padding(PartejarTheme.spacing.space16)) { ContractSetupRequired(ContractSetupRequirements(true, true), {}, {}) }
}

@Preview(name = "Preparação · progresso", widthDp = 375, heightDp = 850, fontScale = 1.3f)
@Composable private fun ContractSetupProgressPreview() = PartejarTheme(ThemeMode.DARK) {
    Column(Modifier.padding(PartejarTheme.spacing.space16)) { ContractSetupRequired(ContractSetupRequirements(false, true), {}, {}) }
}
